<template>
  <ValidationObserver ref="form">
    <div class="grid">
      <div class="vx-row">
        <div class="vx-col w-full">
          <vx-input-group class="mt-3">
            <label>{{ $t('Imagen') }}</label>
            <ImageDropzone ref="images" :files="files"></ImageDropzone>
          </vx-input-group>
        </div>
        <div class="vx-col md:w-3/3 w-full mt-2">
          <p style="color: rgba(var(--vs-warning), 1) !important">
            <font-awesome-icon class="mr-2 ml-2" :icon="['fa', 'exclamation-triangle']" />
            {{ $t('warningImagesBanner') }}
          </p>
        </div>
        <div class="vx-col w-full">
          <vx-input-group class="mb-3 mt-5">
            <ValidationProvider name="URL Banner" rules="required" v-slot="{ errors }">
              <vs-input label-placeholder="URL Banner" v-model="bannerForm.url" class="w-full" />
              <p class="text-danger">{{ errors[0] }}</p>
            </ValidationProvider>
          </vx-input-group>
        </div>
        <div class="vx-col md:w-1/2 w-full mt-4 mb-3">
          <vs-checkbox v-model="isPermanent">{{ $t('banner.AlwaysBannerText') }}</vs-checkbox>
        </div>
        <div v-if="!isPermanent" class="vx-col md:w-9/12 w-full mb-5">
          <CalendarRangeInput v-model="dateRange" class="w-full"></CalendarRangeInput>
        </div>
        <div class="vx-col w-full">
          Activar banner:
          <vs-switch v-model="bannerForm.active"></vs-switch>
        </div>
        <div class="vx-col w-full text-right">
          <vs-button
            depressed
            color="success"
            type="border"
            class="mr-2"
            @click.prevent="handleSubmit">
            {{ $t('banner.EditBanner') }}
          </vs-button>
        </div>
      </div>
    </div>
  </ValidationObserver>
</template>
<script>
  import ImageDropzone from '../ImageDropzone';
  import CalendarRangeInput from '../calendar-range-input/CalendarRangeInput.vue';
  import { mapActions, mapGetters, mapMutations } from 'vuex';

  export default {
    props: {
      isGeneric: {
        type: Boolean,
        required: true
      },
      banner: {
        type: Object,
        required: true
      },
      idRestaurant: {
        type: Number,
        required: false
      }
    },
    expose: ['resetForm'],
    components: {
      ImageDropzone,
      CalendarRangeInput
    },
    data() {
      return {
        bannerForm: {},
        files: {},
        isPermanent: false,
        datePermanent: '9999-12-31'
      };
    },
    created() {
      if (this.banner.finished_at === this.datePermanent || this.banner.finished_at === null) {
        this.isPermanent = true;
      }

      this.bannerForm = this.createBannerForm(this.banner);
      this.bannerFormOriginal = JSON.stringify(this.bannerForm);

      const files = new Array();
      const m = this.bannerForm.path.match(/.*\/(.+?)\./);
      let name = this.bannerForm.path;
      if (m && m.length > 1) {
        name = m[1];
      }
      const image = {
        name,
        url: this.bannerForm.path,
      };
      files.push(image);

       this.files = files;
    },
    computed: {
      ...mapGetters({
        currentRestaurant: 'getCurrentRestaurant'
      }),
      dateRange: {
        set (val) {
          this.bannerForm.started_at = val.fromDate;
          this.bannerForm.finished_at = val.toDate;
        },
        get () {
          return {
            fromDate: this.bannerForm.started_at,
            toDate: this.bannerForm.finished_at
          }
        }
      },
    },
    methods: {
      ...mapActions({
        editBanner: 'editBanner',
        getBanner: 'getItemBanner'
      }),
      ...mapMutations({
        setBanner: 'setItemBanner',
        loading: 'loading',
        setpopupEditBanner: 'setpopupEditBanner'
      }),
      createBannerForm(banner) {
        let finishedDate = '';
        if (!this.isPermanent) finishedDate = banner.finished_at;

        return {
          id: banner.id,
          path: banner.path,
          url: banner.url,
          active: banner.active,
          started_at: banner.started_at,
          finished_at: finishedDate,
          restaurant_id: banner.restaurant_id
        };
      },
      createFormData() {
        const data = this.$refs.images.getFormData();
        const url = this.bannerForm.url.includes('http') ? this.bannerForm.url : `https://${this.bannerForm.url}`;

        data.append('url', url);
        data.append('active', this.bannerForm.active ? 1 : 0);
        data.append('restaurant_id', this.bannerForm.idRestaurant ? this.bannerForm.idRestaurant : 0);

        if (this.isPermanent) {
          data.append('started_at', '');
          data.append('finished_at', '');
        } else {
          data.append('started_at', this.bannerForm.started_at);
          data.append('finished_at', this.bannerForm.finished_at);
        }

        return data;
      },
      isFile(input) {
        if ('File' in window && input instanceof File) return true;
        else return false;
      },checkImages(){
        global.jQuery = require('jquery');
        var $ = global.jQuery;
        const vsSelectedCategories=document.getElementsByClassName('dz-preview')[0];
        if(vsSelectedCategories!==undefined&&vsSelectedCategories)return true;
        else return false;
      },
      handleSubmit() {
        this.$refs.form.validate().then((success) => {
          const formData = this.createFormData();
          if (!this.checkImages()) {
            success = false;
          }
          if (!success) {
            setTimeout(() => {
              let textAux = '';
              const errors = this.$refs.form.errors;
              if(errors&&errors!==undefined){
              Object.keys(errors).forEach((key) => {
                const error = errors[key];
                if (error.length) {
                  error.forEach(function (text) {
                    textAux += `<p>${text}</p>`;
                  });
                }
              });
            }
              if (!this.checkImages()) {
                textAux += '<p>El campo Imágenes es obligatorio</p>';
              }
              this.$store.commit('notifications', {
                title: 'Existen errores en el formulario.',
                color: 'danger',
                text: textAux,
              });
              this.$store.commit('showNotifications', true);
            }, 100);
            return;
          }

          this.submitted = true;

          this.editBanner({
            id: this.bannerForm.id,
            banner: formData,
            restaurant_id: this.idRestaurant
          });

          this.$nextTick(() => {
            this.$refs.form.reset();
          });
        });
      },
    },
    destroyed() {
      this.$store.commit('setpopupEditBanner', false);
    }
}
</script>
<style>
</style>
